import React from 'react';

//import ImgCong from 'assets/images/img_congratulations.svg';

import { RiCheckboxCircleLine } from "react-icons/ri";

import {
  Container,
  Title,
  ContainerInformation,
  CheckBoxContainer,  
  InformationWrap,
  InformationTitle,
  InformationSubTitle,
  InformationText,
  InformationSeparator,
  UllyWrap,
  UllyInformation,
} from './styles';

const TheEnd: React.FC = () => {
  return (
    <Container>
      <Title>Adicionar empresa</Title> 
      <InformationSeparator />     
      <ContainerInformation>
        <CheckBoxContainer>
        <RiCheckboxCircleLine size={60} />
        </CheckBoxContainer>
        <InformationWrap>
          <InformationTitle>Tudo certo!</InformationTitle>
          <InformationSubTitle>
            Sua empresa foi adicionada com sucesso!
          </InformationSubTitle>          
          <InformationText>
            Aproveite todas as facilidades que preparamos especialmente para
            você.
          </InformationText>
        </InformationWrap>
      </ContainerInformation>
      <UllyWrap>
        <UllyInformation>
          Se precisar de ajuda, converse com a Ully, a assitente virtual da
          Ultragaz.
        </UllyInformation>
      </UllyWrap>
    </Container>
  );
};

export default TheEnd;
